import { type Writable, writable } from 'svelte/store';

export class Logger {
	public static tag = '[unknown]';
	static debug(...args: any[]) {
		console.debug(this.tag, ...args);
	}
	static log(...args: any[]) {
		console.log(this.tag, ...args);
	}
	static warn(...args: any[]) {
		console.warn(this.tag, ...args);
	}
	static error(...args: any[]) {
		console.error(this.tag, ...args);
	}
}

export function getFromAnyStorage(key: string) {
	return sessionStorage.getItem(key) ?? localStorage.getItem(key);
}

export interface WritableList<T> extends Writable<T[]> {
	toggle(val: T, matcher?: (a: T, b: T) => boolean): void;
	push(val: T): void;
	remove(predicate: (it: T) => boolean): void;
}
export function writableList<T>(): WritableList<T> {
	const store = writable<T[]>([]);
	return {
		...store,
		toggle(val, matcher) {
			store.update((vals) => {
				if (vals.find((existing) => (matcher ? matcher(existing, val) : existing === val))) {
					return vals.filter((v) => (matcher ? !matcher(v, val) : v !== val));
				}
				return [...vals, val];
			});
		},
		push(val) {
			store.update((vals) => [...vals, val]);
		},
		remove(predicate) {
			store.update((vals) => vals.filter((it) => !predicate(it)));
		},
	};
}
